import { nanoid } from 'nanoid';
import moment from 'moment';
import localization from 'moment/locale/it';
import routeCodes from 'common/constants/route-codes';
import { capitalizeFirstLetter } from 'utils';
import auth from '../libs/api/auth';

export const UserRoles = {
  client: 'client',
  administrator: 'administrator',
};

class DataHelper {
  static getDishesByCategoryCombined = (dishes) => {
    if (!dishes) return dishes;

    const dishesByCategory = [];

    const categories = [];

    dishes.forEach((dish) => {
      const { category } = dish;
      if (category) {
        const repeatedCategory = categories.find((i) => i.id === category.id);
        if (!repeatedCategory) {
          categories.push(category);
        }
      }
    });

    categories.forEach((category) => {
      const currentlyDishesByCategory = dishes.filter(
        (i) => i.category?.id === category.id,
      );
      dishesByCategory.push({
        ...category,
        items: currentlyDishesByCategory,
      });
    });

    return dishesByCategory;
  };

  static getSuperAdminDataKey = (variant) => {
    let key = '';
    switch (variant) {
      case 'admin_bonus_discover_new_restaurants':
        key = 'admin_bonus_discover_new_restaurant';
        break;
      case 'admin_bonus_every_bookings':
        key = 'admin_bonus_every_booking';
        break;
      case 'admin_bonus_superbonuses':
        key = 'admin_bonus_superbonus';
        break;
      case 'admin_bonus_invite_friends':
        key = 'admin_bonus_invite_friend';
        break;
      case 'admin_bonus_users':
        key = 'admin_bonus_user';
        break;
    }
    return key;
  };

  static getOptionsNewCategory = () => {
    return {
      localId: nanoid(),
      dish_category_id: '',
      for_all_dishes: true,
      dish_ids: [''],
    };
  };

  static getProductsByCategory = (products = [], categoryId) => {
    if (!Array.isArray(products)) return [];

    return [...products].filter(
      (p) => parseInt(p.category?.id) === parseInt(categoryId),
    );
  };

  static dishOptionIsSameOptionCategory = (i, category) => {
    const g = category.localId
      ? i.localId === category.localId
      : i.id === category.id;
    return category.localId
      ? i.localId === category.localId
      : i.id === category.id;
  };

  static getLastDays = (day = new Date(), offset = 14) => {};

  static getConfiguredMoment = () => {
    moment.updateLocale('it', localization);
    return moment;
  };

  static getUniqueRowsFormList = (list = [], key = 'id') => {
    return Array.from(new Set(list.map((i) => i[key]))).map((id) => {
      return {
        [key]: id,
        ...list.find((f) => f[key] === id),
      };
    });
  };

  static getRoutAfterChangeRestaurant = (pathname) => {
    const result = {
      route: routeCodes.home,
      forceRefresh: false,
    };

    if (!pathname) {
      return result;
    }

    if (pathname.includes('settings/configs')) {
      result.route = routeCodes.settingsConfigs;
    }

    if (pathname.includes('settings')) {
      result.route = routeCodes.settingsConfigs;
    }

    if (pathname.includes('menu')) {
      result.route = routeCodes.menu;
    }

    if (pathname === '/') {
      result.forceRefresh = true;
    }

    return result;
  };

  static getMothsDataForSelect = () => {
    const monthsArray = [];
    const m = moment();

    const months = moment.months();
    months.forEach((month) => {
      monthsArray.push({
        id: m.month(month).format('M'),
        title: capitalizeFirstLetter(month),
      });
    });

    return monthsArray;
  };

  static getTeamMemberEditable = (item, authUser) => {
    let editable = false;
    if (authUser?.role === UserRoles.administrator && item.role !== '') {
      return true;
    }

    // if (authUser.)
  };

  static getFromToRange = (value, variant) => {
    const params = {};
    const date = moment().set(variant, variant === 'month' ? (value - 1) : value);
    params.date_from = moment(date).startOf(variant);
    params.date_to = moment(date).endOf(variant);

    return params;
  };

  static getMonthsOrYearForSelect = (variant = 'month') => {
    const result = [];

    if (variant === 'month') {
      const months = moment.months();

      months?.forEach((m, index) => {
        result.push({
          id: index + 1,
          title: m,
        });
      });
    }
    if (variant === 'year') {
      const year = moment().year();
      result.push({
        id: year,
        title: year,
      });

      for (let i = 1; i < 4; i++) {
        const prevYear = moment().subtract(i, 'year');
        result.push({
          id: prevYear.format('YYYY'),
          title: prevYear.format('YYYY'),
        });
      }
    }
    return result;
  };

  static getDaysForSelect = (days = 30) => {
    const result = [];

    for (let i = 1; i < days; i++) {
      result.push({
        id: i,
        title: `${i} giorni`,
      });
    }

    return result;
  };

  static isLighted = (keys, audited_changes = {}) => {
    let changed = false;
    Object.keys(audited_changes).find(k => {
      if (Array.isArray(keys)) {
        return changed = !!keys.find(i => {
          return i === k;
        });
      }
      return changed = keys === k;
    });

    return changed;
  }
}

export default DataHelper;
